// Core
import {combineReducers} from 'redux';

// Reducers
import appliedFiltersReducer from '@deezer/next/shared/store/reducers/appliedFilters';

export default () =>
	combineReducers({
		appliedFilters: appliedFiltersReducer,
	});
